import { useEffect } from "react";
import PropTypes from "prop-types";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

/**
 * Composant de contrôle de session pour les cuisiniers
 * Vérifie la présence et la validité du token cuisinier
 * 
 * @param {function} onSessionExpired - Callback appelé quand la session expire
 */
const SessionCuisinier = ({ onSessionExpired }) => {
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    const raw = localStorage.getItem("cuisinier_actif");
    
    if (raw) {
      try {
        const data = JSON.parse(raw);
        const token = data.access_token;
        
        if (!token) {
          console.log("Token manquant pour le cuisinier");
          handleSessionExpired();
          return;
        }

        const decoded = jwtDecode(token);
        console.log("Token exp:", new Date(decoded.exp * 1000));
        console.log("Current time:", new Date());
        
        const isExpired = decoded.exp * 1000 < Date.now();
        
        if (isExpired) {
          console.log("Le token cuisinier est expiré.");
          handleSessionExpired();
        } else {
          console.log("Token cuisinier valide");
        }
      } catch (e) {
        console.error("Erreur structure du JSON problématique pour cuisinier_actif", e);
        handleSessionExpired();
      }
    } else {
      console.log("Aucun cuisinier actif trouvé");
      if (onSessionExpired) {
        onSessionExpired();
      }
    }
  }, []);

  const handleSessionExpired = () => {
    localStorage.removeItem("cuisinier_actif");
    
    MySwal.fire({
      icon: "warning",
      // title: "Session expirée",
      text: "Votre session cuisine a expiré. Veuillez vous reconnecter.",
      toast: true,
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      customClass: {
        popup: "pixel-toast",
      }
    });

    if (onSessionExpired) {
      onSessionExpired();
    }
  };

  return null; // Ce composant ne rend rien
};

SessionCuisinier.propTypes = {
  onSessionExpired: PropTypes.func,
};

export default SessionCuisinier;